import styled from "styled-components";

export const Container = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 2px;
  a {
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    color: #b0b0b0;
    text-decoration: none;
    transition: all 0.15s;
    span {
      display: block;
    }
    &:hover {
      background: rgba(255, 255, 255, 0.1);
      color: #ffffff;
    }
  }
  .active {
    background: rgba(255, 255, 255, 0.15);
    color: #ffffff;
  }
`;
